import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Progress Pencil"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-progress-pencil',
    templateUrl: './icon-progress-pencil.component.html',
    styleUrls: ['./icon-progress-pencil.component.scss'],
    standalone: false
})
export class IconProgressPencilComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
